module.exports = __webpack_public_path__ + "img/error.89f8539d.svg";